import { render, staticRenderFns } from "./btnPreloader.vue?vue&type=template&id=128c2b5b&lang=pug&"
import script from "./btnPreloader.vue?vue&type=script&lang=js&"
export * from "./btnPreloader.vue?vue&type=script&lang=js&"
import style0 from "./btnPreloader.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "btnPreloader.vue"
export default component.exports